import { asSingleStyleConfig } from '../../../../utils/theme';
import { getColor } from '../../../../theme-tools';
import { getDefaults } from './input';
var checkedControlStyles = {
  color: 'blue.600',
  bg: 'white',
  _focus: {
    borderColor: '#666666'
  },
  _disabled: {
    bg: '#EEEEEE',
    color: '#6199C3'
  },
  _invalid: {
    bg: 'white'
    // color: 'white',
  }
};

function baseStyleControl(props) {
  var {
    theme
  } = props;
  var {
    focusBorderColor,
    errorBorderColor,
    focusBoxShadowColor,
    errorBoxShadowColor
  } = getDefaults(props);
  return {
    w: '100%',
    border: '1px solid',
    borderRadius: 'unset',
    borderColor: '#666666',
    _checked: checkedControlStyles,
    _indeterminate: checkedControlStyles,
    _focus: {
      borderColor: focusBorderColor,
      boxShadow: "0 0 0 3px ".concat(getColor(theme, focusBoxShadowColor))
    },
    _invalid: {
      borderColor: errorBorderColor,
      borderWidth: '2px',
      boxShadow: 'none',
      _focus: {
        boxShadow: "0 0 0px 3px ".concat(getColor(theme, errorBoxShadowColor))
      }
    }
  };
}
var baseStyle = props => ({
  control: baseStyleControl(props)
});
export default asSingleStyleConfig({
  baseStyle
});